import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { selectAppState } from 'store/config/selectors';

import useGetAppEndUavParams from 'services/uav/useGetAppEndUavParams';
import useGetAppStartUavParams from 'services/uav/useGetAppStartUavParams';
import { logUavAnalytics } from 'services/uav/utils';

import usePrevious from 'utils/hooks/usePrevious';

const useLogAppStateChange = () => {
    const appState = useSelector(selectAppState);
    const prevState = usePrevious(appState);

    const { getAppStartUavParams } = useGetAppStartUavParams();
    const { getAppEndUavParams } = useGetAppEndUavParams();

    useEffect(() => {
        if (
            (prevState === 'inactive' || prevState === 'background') &&
            appState === 'active'
        ) {
            logUavAnalytics(getAppStartUavParams());
        }

        if (
            (appState === 'inactive' || appState === 'background') &&
            prevState === 'active'
        ) {
            logUavAnalytics(getAppEndUavParams());
        }
    }, [appState]);
};

export default useLogAppStateChange;
